import styled, { css } from 'styled-components';
import StyledLogin from '../LoginPage/StyledLogin';
import { StyledCilentHeaders } from '../GiftCard/StyledCilentHeaders';
import endPoints from '../../config/endPoints';

const StyledClientLogin = styled.section`
    background:${(props) => props.theme.ghostWhite};
    overflow-x: hidden;
    .products-view{
      .filters-bg{
        border: 1px solid ${(props) => props.theme.webGray};
        border-radius: 9px;
        padding-bottom: 10px;
      }
    }
    .heading{
      color: ${(props) => props.theme.LandingBlack};
    }
    header {
      ${({ header_background }) => css`
        background: ${header_background};
        img{
          width:30%;
        }
      `}
      .cilent-fixed-nav{
        position: fixed;
        z-index: 2;
        width: 100%;
        top: 0px;
        left: 0px;
        right: 0px;
      }
      .client-header-bg{
        background: ${(props) => props.theme.ghostWhite};
        box-shadow: 0px 4px 6px 1px ${(props) => props.theme.borderGray};
        padding: 16px 0px;
        .icon-raise{
          cursor: pointer;
          color: ${(props) => props.theme.LandingBlack};
          font-size: 20px;
          margin-right: 20px;
        }
        .cart{
          position: relative;
          .badge{
            position: absolute;
            left: 22px;
            top: -12px;
            font-size: 10px;
            font-weight: bold;
            color: ${(props) => props.theme.primaryColor};
          }
        }
        .manipal-home-logo{
          width: 30px;
          margin-right: 20px;
          vertical-align: sub;
        }
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
          .icon-raise{
            font-size: 18px;
            padding-right: 10px;
          }
        };
      }
      .client-secoundary-header-bg{
        background: ${(props) => props.theme.whiteColor};
      }
      .client-header{
        padding:0px;

        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
          padding: 10px;
          .mobile-center{
            text-align: center;
          }
        };
      }
    }
    .portal_name {
      ${({ portal_color }) => css`
      font-size:18px;
      color:${portal_color};
      `}
      .cilent-logo{
        width: auto;
        height: 60px;
      }
      .brand-logo{
        width: auto;
        height: 70px;
      }
      .prop-corp-gift{
        &.xmas-spec-logo{
          width: 25%;
        }
      }
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
        .cilent-logo{
          height: 35px;
        }
        .brand-logo{
          height: 50px;
          padding-left: 10px;
        }
        .prop-corp-gift{
          width: 50%;
          &.xmas-spec-logo{
            width: 40%;
          }
        }
      };
    }
    h1{
       ${({ h1_color }) => css`
        font-size:22px;
        color:${h1_color};
       `}
    }
    p{
        font-size: 14px;
        line-height: 26px;
        color: ${(props) => props.theme.grayColor};
        text-align:justify;
    }
    .mid-layer{
        background :url(${endPoints.BackgroundImg}) ${(props) => props.theme.lightWhite};
        text-align:center;
        padding:50px 0px;
        margin-top:50px;
        p{
        ${({ midLayerTextAlign }) => css`
          text-align:${midLayerTextAlign};
        `}
        }
        span{
          line-height: 28px;
        }
        .footer-links-manipalcigna{
          padding-left: 0px;
          list-style-type: none;
          li{
            display: inline-block;
            padding: 0px 10px;
          }
        }
    }
    footer{
      margin:10px 0px;
      text-align:center;
      font-size:12px;
      color:${(props) => props.theme.secondaryColor};
      img{
          vertical-align: middle;
          width: 8%;
          margin-left: 4px;
          @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
            width: 20%;
          };
        }
    }

.login{
    box-shadow: 0px 0px 15px ${(props) => props.theme.matrixPurple};
    background:${(props) => props.theme.whiteColor};
    margin-top: -64px;
    z-index: 9;
    position: relative;
    padding-bottom: 30px;
    border-radius: 4px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
      margin: 0;
    };
    h2{
      ${({ login_background }) => css`
        background: ${login_background};
        padding:20px 25px;
        margin:0px;
        color:${(props) => props.theme.whiteColor};
        font-size:18px;
        font-weight:normal;
        border-radius: 4px;
      `}
    }
    ${StyledLogin}{
       .login_popup{
          margin:0 0 0 0;
          @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          width:100%;
        };
      }
      .links{
      &.left{
          float:left;
          height:auto;
          background:none;
      }
      &.right{
          float:right;
          height:auto;
      }
    }
  }
}
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
    .mobile-center{
      text-align: center;
    }
  }
.support-box{
  border: 1px solid ${(props) => props.theme.lightGray}; 
  width: 50%; 
  border-radius: 10px;
  font-size: 14px;
  line-height: 24px; 
  color: ${(props) => props.theme.grayColor};
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    width: 100%;
  };
}
.portal_name {
  ${StyledCilentHeaders}
}
`;

export default StyledClientLogin;



// WEBPACK FOOTER //
// client/containers/ClientLogin/styledClientLogin.js